export enum TachoTypeData {
    Driving = 1,
    Work = 2,
    Rest = 3,
    Availability = 4,
}

export enum TachScheduleFileStatus {
  Unknown = 0,
  Waiting = 1,
  NoTachoService = 2,
  NoCardReader = 3,
  NoFleetCardInserted = 4,
  VehicleOffline = 5,
  DriverCardNotFound = 6,
  DownloadInProgress = 7,
  DownloadError = 8,
  DownloadSuccessful = 9,
  AuthorizationInProgress = 10,
  FleetCardBusy = 11,
  AuthorizationError = 12,
  TachoCommunicationErrorX = 13,
  TachoCommunicationErrorN4 = 14,
  TachoCommunicationErrorN5 = 15,
  TachoResponseNegative = 16,
  TachoServiceResponseError = 17,
  FleetCardCommunicationError = 18,
  FleetCardAuthenticationFail = 19,
  AuthorizationException = 20,
  DownloadException = 21,
  WaitingForIgnition = 22
}
